import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent, TileComponent } from '@tecalisdev/infinity';
import { ERROR_CODE, ERROR_STATUS, IErrorResponse } from '../../models/error.models';

@Component({
	selector: 'app-error',
	templateUrl: './error.component.html',
	styleUrls: ['./error.component.scss'],
	imports: [TileComponent, ButtonComponent, TranslatePipe],
})
export class ErrorComponent {
	@Input() errorConfig: IErrorResponse = {
		code: ERROR_STATUS.ACCESS,
		error: null,
	};

	public ERROR_CODE = ERROR_CODE;
	public ERROR_STATUS = ERROR_STATUS;
}
